
/* CONFIG — these endpoints/keys are placeholders.
   Replace with the production values from the Aroma360 ops team. */
const A360_INTEGRATION = {
  recaptcha: {
    siteKey: "6LfeJyUqAAAAAPkVgk_VuyW6b52woueyz4seDRCt"
  },
  klaviyo: {
    // Public Klaviyo company ID (safe to expose client-side)
    companyId: "kaE4yM",
    // Klaviyo list ID for "Charity Event — Boca 2026"
    listId:    "VVVJYL",
    // Custom event name that triggers the welcome flow
    eventName: "Charity Event Lead — $50/$100"
  },
  oneText: {
    // OneText API base URL
    apiBaseUrl: "https://onetext.com/api",
    // API key for Basic auth (obtain from dashboard: https://onetext.com/dashboard/merchant/flows/automations?triggerToken=onetext_trigger_production_019e08a0-c04e-7094-bd1a-7f2d6ac35ac3)
    apiKey: "Basic b25ldGV4dF9hY2NvdW50X3Byb2R1Y3Rpb25fMDE5ODlhNDMtNzcyNC03MTFhLWJlN2MtYmU5MWVjOWNkYWJhOm9uZXRleHRfc2VjcmV0X3Byb2R1Y3Rpb25fOTFlYjc2MjEtMTUxZC00YzliLTk1MDMtOTEyZWNlNjQzODVk",
    // Trigger token for the special offer flow
    triggerToken: "onetext_trigger_production_019e08a0-c04e-7094-bd1a-7f2d6ac35ac3"
  },
  // Event metadata stamped on every lead so reporting can segment
  source: "charity-event-boca-2026"
};

/* ---------- form behavior ---------- */
const form     = document.getElementById('lead-form');
const submitBtn= document.getElementById('submit-btn');
const consent  = document.getElementById('consent-box');
const consentErr= document.getElementById('consent-err');

const fields = ['firstName','lastName','email','phone'].map(id => ({
  id,
  el: document.getElementById(id),
  wrap: document.getElementById(id).closest('.field'),
  interacted: false
}));

// Bot protection: track form load time
const formLoadTime = Date.now();
const MIN_SUBMISSION_TIME_MS = 5000; // 5 seconds minimum

// Bot protection: track field interactions
fields.forEach(f => {
  f.el.addEventListener('focus', () => { f.interacted = true; });
  f.el.addEventListener('blur', () => { f.interacted = true; });
});

// Bot protection: check for duplicate submissions
function isDuplicateSubmission(email) {
  const submittedEmails = JSON.parse(localStorage.getItem('a360_submitted_emails') || '[]');
  const submittedRecently = submittedEmails.some(entry =>
    entry.email === email && (Date.now() - entry.timestamp < 86400000) // 24 hours
  );
  return submittedRecently;
}

function recordSubmission(email) {
  const submittedEmails = JSON.parse(localStorage.getItem('a360_submitted_emails') || '[]');
  submittedEmails.push({ email, timestamp: Date.now() });
  // Keep only last 100 submissions
  if (submittedEmails.length > 100) submittedEmails.shift();
  localStorage.setItem('a360_submitted_emails', JSON.stringify(submittedEmails));
}

function initRecaptcha() {
  if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.enterprise.render === 'function') {
    try {
      grecaptcha.enterprise.render('recaptcha_special_offer_boca', {
        sitekey: A360_INTEGRATION.recaptcha.siteKey
      });
      console.log('[reCAPTCHA] Rendered successfully');
    } catch (e) {
      console.error('[reCAPTCHA] render error:', e);
    }
  } else {
    console.warn('[reCAPTCHA] grecaptcha not available yet, retrying...');
    setTimeout(initRecaptcha, 500);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecaptcha);
} else {
  initRecaptcha();
}

function validateField(f) {
  const v = (f.el.value || '').trim();
  let ok = !!v;
  if (ok && f.id === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  if (ok && f.id === 'phone') {
    const digits = v.replace(/[^\d]/g, '');
    ok = digits.length >= 10;
  }
  f.wrap.classList.toggle('has-error', !ok);
  f.el.classList.toggle('error', !ok);
  return ok;
}

fields.forEach(f => {
  f.el.addEventListener('blur', () => { if (f.el.value.trim()) validateField(f); });
  f.el.addEventListener('input', () => {
    if (f.wrap.classList.contains('has-error')) validateField(f);
  });
});

consent.addEventListener('change', () => {
  if (consent.checked) {
    consentErr.style.display = 'none';
    document.getElementById('consent').classList.remove('has-error');
  }
});

/* ---------- submit ---------- */
async function postKlaviyo(payload) {
  // Subscribe-to-list + identify in one shot via client-side endpoint.
  // NOTE: requires a valid public companyId. Wrapped in try/catch so the UX
  // never blocks on a network failure during the event.
  const id = A360_INTEGRATION.klaviyo.companyId;
  if (!id || id.startsWith('PASTE_')) {
    console.warn('[Klaviyo] companyId not configured — skipping.');
    return { skipped: true };
  }
  try {
    console.log('[Klaviyo] Sending subscription with payload:', payload);
    const body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: A360_INTEGRATION.source,
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: payload.email,
                phone_number: payload.phoneE164,
                first_name: payload.firstName,
                last_name: payload.lastName,
                properties: {
                  source: A360_INTEGRATION.source,
                  event:  A360_INTEGRATION.klaviyo.eventName,
                  consent_marketing: true
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: A360_INTEGRATION.klaviyo.listId } }
        }
      }
    };
    const r = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(id)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    });
    console.log('[Klaviyo] Response:', { ok: r.ok, status: r.status });
    return { ok: r.ok, status: r.status };
  } catch (e) {
    console.warn('[Klaviyo] error', e);
    return { error: String(e) };
  }
}

async function postOneText(payload) {
  const config = A360_INTEGRATION.oneText;
  if (!config.apiKey || config.apiKey.includes('PASTE_')) {
    console.warn('[OneText] apiKey not configured — skipping.');
    return { skipped: true };
  }

  try {
    // Step 1: Opt-in subscriber to suppress welcome flow
    console.log('[OneText] Step 1: Opting in subscriber with allowWelcomeFlow=false');
    const optinUrl = `${config.apiBaseUrl}/optin`;
    const optinBody = {
      phone: payload.phoneE164,
      email: payload.email,
      allowWelcomeFlow: false,
      channel: "sms_mms"
    };

    const optinRes = await fetch(optinUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': config.apiKey.startsWith('Basic ') ? config.apiKey : `Basic ${btoa(config.apiKey + ':')}`
      },
      body: JSON.stringify(optinBody)
    });

    if (!optinRes.ok) {
      console.warn(`[OneText] Step 1 failed: HTTP ${optinRes.status}`);
      return { ok: false, status: optinRes.status, step: 'optin' };
    }

    const optinData = await optinRes.json();
    console.log('[OneText] Step 1 response:', optinData);

    if (!optinData.accountToken) {
      console.warn('[OneText] Step 1: accountToken not present in response');
      return { ok: false, reason: 'missing accountToken' };
    }

    // Step 2: Trigger the special offer flow
    console.log('[OneText] Step 2: Triggering special offer flow');
    const triggerUrl = `${config.apiBaseUrl}/flow/custom/start`;
    const triggerBody = {
      triggerToken: config.triggerToken,
      phoneNumbers: [payload.phoneE164],
      parameters: {}
    };

    const triggerRes = await fetch(triggerUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': config.apiKey.startsWith('Basic ') ? config.apiKey : `Basic ${btoa(config.apiKey + ':')}`
      },
      body: JSON.stringify(triggerBody)
    });

    console.log('[OneText] Step 2 response:', { ok: triggerRes.ok, status: triggerRes.status });
    return { ok: triggerRes.ok, status: triggerRes.status, step: 'trigger' };

  } catch (e) {
    console.warn('[OneText] error:', e);
    return { error: String(e) };
  }
}

function toE164(raw) {
  const digits = (raw || '').replace(/[^\d]/g, '');
  if (digits.length === 10) return '+1' + digits;
  if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
  return digits ? '+' + digits : '';
}

form.addEventListener('submit', async (e) => {
  e.preventDefault();

  // Honeypot: reject if bot filled the hidden field
  const honeypot = document.getElementById('website');
  if (honeypot && honeypot.value.trim()) {
    console.warn('[Honeypot] Bot detected — rejecting submission');
    return;
  }

  // Time-based validation: require minimum submission time
  const submissionTime = Date.now() - formLoadTime;
  if (submissionTime < MIN_SUBMISSION_TIME_MS) {
    console.warn(`[Bot Check] Form filled too quickly (${submissionTime}ms < ${MIN_SUBMISSION_TIME_MS}ms)`);
    return;
  }

  // Field interaction validation: ensure user interacted with fields
  const allFieldsInteracted = fields.every(f => f.interacted);
  if (!allFieldsInteracted) {
    console.warn('[Bot Check] Not all fields were interacted with');
    return;
  }

  let allOk = true;
  fields.forEach(f => { if (!validateField(f)) allOk = false; });

  if (!consent.checked) {
    consentErr.style.display = 'block';
    document.getElementById('consent').classList.add('has-error');
    allOk = false;
  }

  if (!allOk) {
    // Scroll to first error
    const firstErr = document.querySelector('.field.has-error, .consent.has-error');
    if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  // Get reCAPTCHA token
  const recaptchaToken = grecaptcha.enterprise.getResponse();
  if (!recaptchaToken) {
    console.warn('[reCAPTCHA] No token available');
  }

  // Build payload
  const payload = {
    firstName: document.getElementById('firstName').value.trim(),
    lastName:  document.getElementById('lastName').value.trim(),
    email:     document.getElementById('email').value.trim(),
    phone:     document.getElementById('phone').value.trim(),
    recaptchaToken: recaptchaToken
  };
  payload.phoneE164 = toE164(payload.phone);

  // Duplicate detection: check if email already submitted recently
  if (isDuplicateSubmission(payload.email)) {
    console.warn('[Bot Check] Duplicate submission detected for email:', payload.email);
    return;
  }

  // UI: loading state
  submitBtn.classList.add('loading');
  submitBtn.disabled = true;
  submitBtn.querySelector('.label-text').textContent = 'Sending your gift…';

  // Fire integrations in parallel; don't block the user if one fails — the lead
  // is captured locally and event staff can re-import any failures.
  const results = await Promise.allSettled([
    postKlaviyo(payload),
    postOneText(payload)
  ]);
  console.log('[Aroma360] integration results', results);

  // Stamp a local backup so nothing is lost even if both endpoints fail
  try {
    const backup = JSON.parse(localStorage.getItem('a360_leads') || '[]');
    backup.push({ ...payload, ts: new Date().toISOString(), source: A360_INTEGRATION.source });
    localStorage.setItem('a360_leads', JSON.stringify(backup));
  } catch (_) {}

  // Record submission for duplicate detection
  recordSubmission(payload.email);

  // Personalize thank-you & swap views
  document.getElementById('ty-name').textContent = payload.firstName;
  document.getElementById('ty-email').textContent = `to ${payload.email}`;
  document.getElementById('ty-phone').textContent = `to ${payload.phone}`;
  document.body.classList.add('submitted');
  document.getElementById('thanks').classList.add('show');
  window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
});